var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Ref',{attrs:{"details":_vm.itemData}}),_c('Details',{attrs:{"details":_vm.itemData}}),_c('PackagingList',{attrs:{"details":_vm.itemData}}),_c('Variant',{attrs:{"details":_vm.itemData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }